document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hover-video[data-video-src]').forEach(function (wrap) {
    var src = wrap.getAttribute('data-video-src');
    var video = wrap.querySelector('.hover-video__video');
    if (!src || !video) return;

    var loaded = false;
    function ensureSrc() {
      if (!loaded) { video.src = src; loaded = true; }
    }
    function play() {
      wrap.classList.add('is-hovering');
      try { video.play(); } catch(e) {}
    }
    function stop() {
      wrap.classList.remove('is-hovering');
      try { video.pause(); video.currentTime = 0; } catch(e) {}
    }

    wrap.addEventListener('mouseenter', function(){ ensureSrc(); play(); });
    wrap.addEventListener('mouseleave', stop);
    wrap.addEventListener('focusin', function(){ ensureSrc(); play(); });
    wrap.addEventListener('focusout', stop);

    // Pause if card leaves the viewport
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (!en.isIntersecting) stop(); });
    }, { threshold: 0 });
    io.observe(wrap);
  });
});

